/**
 * Product Gallery Component JavaScript
 * Initialize Swiper with Thumbs gallery
 */

(function() {
  'use strict';

  /**
   * Initialize all product gallery instances
   */
  function initializeProductGalleries(retryCount = 0) {
    const maxRetries = 50; // Max 5 seconds of retries

    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      if (retryCount < maxRetries) {
        console.warn('Swiper library not loaded for product gallery, retrying in 100ms... (attempt ' + (retryCount + 1) + '/' + maxRetries + ')');
        setTimeout(function() {
          initializeProductGalleries(retryCount + 1);
        }, 100);
        return;
      } else {
        console.error('Swiper library failed to load after ' + maxRetries + ' attempts.');
        return;
      }
    }

    // Initialize each product gallery
    const galleries = document.querySelectorAll('.product-gallery');
    
    galleries.forEach(function(gallery) {
      // Skip if already initialized
      if (gallery.dataset.initialized === 'true') return;
      
      const galleryId = gallery.dataset.galleryId;
      const mainSwiperEl = gallery.querySelector('.product-gallery__main');
      const thumbsSwiperEl = gallery.querySelector('.product-gallery__thumbs');

      if (!mainSwiperEl) return;

      let thumbsSwiper = null;

      // Initialize thumbs swiper first if it exists
      if (thumbsSwiperEl) {
        thumbsSwiper = new Swiper(thumbsSwiperEl, {
          spaceBetween: 12,
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
          direction: 'horizontal',
          breakpoints: {
            320: {
              direction: 'horizontal',
              slidesPerView: 3,
              spaceBetween: 8,
            },
            576: {
              direction: 'horizontal',
              slidesPerView: 4,
              spaceBetween: 10,
            },
            768: {
              direction: 'horizontal',
              slidesPerView: 5,
              spaceBetween: 12,
            },
            992: {
              direction: 'vertical',
              slidesPerView: 'auto',
              spaceBetween: 8,
            },
          },
        });
      }

      // Initialize main swiper
      const mainSwiperOptions = {
        spaceBetween: 0,
        grabCursor: true,
        slidesPerView: 1,
      };

      // Add thumbs controller if thumbsSwiper exists
      if (thumbsSwiper) {
        mainSwiperOptions.thumbs = {
          swiper: thumbsSwiper,
        };
      }

      const mainSwiper = new Swiper(mainSwiperEl, mainSwiperOptions);

      // Mark as initialized
      gallery.dataset.initialized = 'true';

      // Initialize Fancybox for lightbox if available
      if (typeof Fancybox !== 'undefined' && galleryId) {
        Fancybox.bind('[data-fancybox="' + galleryId + '"]', {
          Thumbs: {
            autoStart: true,
          },
          Images: {
            zoom: true,
          },
        });
      }
    });
  }

  // Swipers initialized inside a still-hidden Bootstrap modal measure zero
  // dimensions, which breaks the thumbnail click mapping. Refresh them once
  // the modal is fully visible.
  document.addEventListener('shown.bs.modal', function(event) {
    event.target.querySelectorAll('.product-gallery .swiper').forEach(function(el) {
      if (el.swiper) {
        el.swiper.update();
      }
    });
  });

  /**
   * Wait for DOM to be ready
   *
   * Galleries can also arrive through AJAX (e.g. the product variant modal),
   * so initialization runs as a Drupal behavior when Drupal is available.
   * Re-runs are safe: initialized galleries are skipped via a data attribute.
   */
  function init() {
    if (typeof Drupal !== 'undefined') {
      Drupal.behaviors.loeProductGallery = {
        attach: function() {
          initializeProductGalleries();
        },
      };
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProductGalleries);
    } else {
      initializeProductGalleries();
    }
  }

  init();
})();
